module.exports = __webpack_public_path__ + "static/media/2_step5.3d97c238.png";